/**
 * Filter Match types used for catalog filter matching
 */
export enum FilterMatchTitle {
  GENESYS_PRODUCT = 'Genesys Product',
  INSTRUCTION_TYPE = 'Instruction Type',
  ROLE = 'Role',
  TOPIC = 'Topic',
  COURSE_AVAILABILITY = 'Availability',
}
